<template>
	<vx-card no-shadow>
		<routing-result-info v-if="standardOutput" :standardOutput="standardOutput"></routing-result-info>
		<div class="export-table">
			<vs-table :data="routedVehicles" v-model="selectedUsers" search>
				<template slot="header"> </template>

				<template slot="thead">
					<vs-th> {{ $t("Routing.Resource") }} </vs-th>
					<vs-th> {{ $t("Routing.DistanceRoute") }} (Km)</vs-th>
					<vs-th>
						{{ $t("RouterSelection.VisitPoints") | title }}
					</vs-th>
					<vs-th>
						{{ $t("Routing.MinimumRouteTime") | title }}
					</vs-th>
					<vs-th>
						{{ $t("Routing.RouteResult.DrivingTimme") | title }}
					</vs-th>
					<vs-th>
						{{ $t("Routing.CreateVisitPoint.ServiceTime") }}
					</vs-th>
					<vs-th>
						{{ $t("ResourceModule.TotalCost") }}
					</vs-th>
					<vs-th> {{ $t("Colors") }} </vs-th>
				</template>
				<template slot-scope="{data}">
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>{{ data[indextr].vehicle_id }}</vs-td>
						<vs-td>{{ data[indextr].distance_route | removeDecimals }}</vs-td>
						<vs-td>{{ data[indextr].total_visit_points }}</vs-td>
						<vs-td>{{ data[indextr].minimum_route_time }}</vs-td>
						<vs-td>{{ data[indextr].minimum_driving_time }}</vs-td>
						<vs-td>{{ data[indextr].minimum_time_service }}</vs-td>
						<vs-td>
							<span>{{
								data[indextr].costs.total != null ? data[indextr].costs.total.toFixed(3) : 0
							}}</span>
						</vs-td>
						<vs-td><vs-chip :color="`#${data[indextr].color}`"></vs-chip></vs-td>
						<template slot="expand">
							<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
								<vs-tab :label="$t('Routing.Title.VisitPoints')">
									<vue-perfect-scrollbar class="scroll-area" :settings="settings">
										<optimization-result-routes
											:routed_visit_points="data[indextr].routed_visit_points"
											:thead_property_names="thead_property_names"
											:typeRouting="selectedRoutingType"
										/>
									</vue-perfect-scrollbar>
								</vs-tab>
								<vs-tab :label="$t('Routing.RouteResult.Capacities')">
									<vue-perfect-scrollbar :settings="settings">
										<vs-table
											v-if="data[indextr].vehicle_capacity"
											ref="table"
											v-model="selected"
											search
											:max-items="itemsPerPage"
											:data="data[indextr].vehicle_capacity"
										>
											<div
												slot="header"
												class="flex flex-wrap-reverse items-center flex-grow justify-between mb-4"
											>
												<label class="font-bold">{{
													$t("Capacity.TotalCapacities") +
													": " +
													data[indextr].vehicle_capacity.length
												}}</label>
											</div>
											<template slot="thead">
												<vs-th sort-key="name">{{ $t("Name") }}</vs-th>
												<vs-th sort-key="description">{{
													$t("ResourceModule.Create.CapacityValue")
												}}</vs-th>
												<vs-th sort-key="loadCapacity">{{
													$t("Routing.RouteResult.LoadCapacity")
												}}</vs-th>
												<vs-th sort-key="load">{{ $t("Routing.RouteResult.Load") }}</vs-th>
											</template>
											<template slot-scope="{data}">
												<tbody>
													<vs-tr :data="tr" :key="indextrvr" v-for="(tr, indextrvr) in data">
														<vs-td>
															<p class="product-name font-medium truncate">
																{{ tr.name }}
															</p>
														</vs-td>
														<vs-td>
															<p class="product-category">{{ tr.amount }}</p>
														</vs-td>
														<vs-td>
															<p class="product-category">
																{{ getLoadCapacity(routedVehicles[indextr], tr.name) }}
															</p>
														</vs-td>
														<vs-td>
															<p class="product-category flex items-center">
																<vs-progress
																	v-if="
																		routedVehicles[indextr].load_capacity_percentage
																			.length > 0
																	"
																	class="mr-2"
																	:height="8"
																	:percent="
																		getLoadCapacityPercentage(
																			routedVehicles[indextr],
																			tr.name
																		)
																	"
																	:color="
																		chipColor(
																			getLoadCapacityPercentage(
																				routedVehicles[indextr],
																				tr.name
																			)
																		)
																	"
																></vs-progress>
																{{
																	getLoadCapacityPercentage(
																		routedVehicles[indextr],
																		tr.name
																	) + "%"
																}}
															</p>
														</vs-td>
													</vs-tr>
												</tbody>
											</template>
										</vs-table>
										<p v-else>
											{{ $t("Capacity.NoAssignedCapability") }}
										</p>
										<slot name="alert-message"> </slot>
									</vue-perfect-scrollbar>
								</vs-tab>
								<vs-tab :label="$t('Skills.Skills')">
									<vue-perfect-scrollbar :settings="settings">
										<vs-table
											v-if="data[indextr].vehicle_skills"
											ref="table"
											v-model="selectedSkills"
											search
											:max-items="itemsPerPage"
											:data="data[indextr].vehicle_skills"
										>
											<div
												slot="header"
												class="flex flex-wrap-reverse items-center flex-grow justify-between mb-4"
											>
												<label class="font-bold">{{
													$t("Skills.TotalSkills") +
													": " +
													data[indextr].vehicle_skills.length
												}}</label>
											</div>
											<template slot="thead">
												<vs-th sort-key="name">{{ "Item" }}</vs-th>
												<vs-th sort-key="name">{{ $t("Name") }}</vs-th>
											</template>
											<template slot-scope="{data}">
												<tbody>
													<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
														<vs-td>
															<p class="product-name font-medium truncate">
																{{ indextr + 1 }}
															</p>
														</vs-td>
														<vs-td>
															<p class="product-name font-medium truncate">
																{{ tr }}
															</p>
														</vs-td>
													</vs-tr>
												</tbody>
											</template>
										</vs-table>
										<p v-else>
											{{ $t("Skills.NoSkillsAssigned") }}
										</p>
										<slot name="alert-message"> </slot>
									</vue-perfect-scrollbar>
								</vs-tab>
								<vs-tab v-if="!validateCost(data[indextr].costs)" :label="$t('MODULE_SOURCE.Costs')">
									<vue-perfect-scrollbar :settings="settings">
										<vs-table
											ref="table"
											v-model="selected"
											search
											:max-items="itemsPerPage"
											data="null"
										>
											<div
												slot="header"
												class="flex flex-wrap-reverse items-center flex-grow justify-between mb-4"
											>
												<label class="font-bold">{{
													$t("ResourceModule.TotalCost") + ": " + data[indextr].costs.total !=
													null
														? data[indextr].costs.total.toFixed(3)
														: 0
												}}</label>
											</div>
											<template slot="thead">
												<vs-th sort-key="distance">{{ $t("Optimization.Distance") }}</vs-th>
												<vs-th sort-key="fixed">{{ $t("Optimization.Fixed") }}</vs-th>
												<vs-th sort-key="time">{{ $t("Optimization.Time") }}</vs-th>
												<vs-th sort-key="traveledhour">{{
													$t("Optimization.TraveledHour")
												}}</vs-th>
												<vs-th sort-key="vehicletime">{{
													$t("Optimization.VehicleTime")
												}}</vs-th>
											</template>
											<template>
												<tbody>
													<vs-tr>
														<vs-td>
															<p class="product-category">
																{{
																	data[indextr].costs.distance != null
																		? data[indextr].costs.distance.toFixed(4)
																		: 0
																}}
															</p>
														</vs-td>
														<vs-td>
															<p class="product-category">
																{{
																	data[indextr].costs.fixed != null
																		? data[indextr].costs.fixed.toFixed(4)
																		: 0
																}}
															</p>
														</vs-td>
														<vs-td>
															<p class="product-category">
																{{
																	data[indextr].costs.time != null
																		? data[indextr].costs.time.toFixed(4)
																		: 0
																}}
															</p>
														</vs-td>
														<vs-td>
															<p class="product-category">
																{{
																	data[indextr].costs.traveled_hour != null
																		? data[indextr].costs.traveled_hour.toFixed(4)
																		: 0
																}}
															</p>
														</vs-td>
														<vs-td>
															<p class="product-category">
																{{
																	data[indextr].costs.vehicle_time != null
																		? data[indextr].costs.vehicle_time.toFixed(4)
																		: 0
																}}
															</p>
														</vs-td>
													</vs-tr>
												</tbody>
											</template>
										</vs-table>
									</vue-perfect-scrollbar>
								</vs-tab>
							</vs-tabs>
						</template>
					</vs-tr>
				</template>
			</vs-table>
		</div>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";
import moduleRouting from "@/store/routing/moduleRouting.js";
import RoutingResultInfo from "./RoutingResultInfo.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import OptimizationResultRoutes from "./OptimizationResultRoutes.vue";

export default {
	name: "OptimizationResult",
	components: {
		vSelect,
		RoutingResultInfo,
		VuePerfectScrollbar,
		OptimizationResultRoutes,
	},
	data() {
		return {
			itemsPerPage: 10,
			selected: [],
			selectedSkills: [],
			activeTab: 0,
			fileName: "",
			formats: ["xlsx", "csv", "txt"],
			cellAutoWidth: true,
			selectedFormat: "xlsx",
			headerTitle: ["Id", "Email", "Username", "Name", "Website"],
			headerVal: ["id", "email", "username", "name", "website"],
			routedVehicles: [],
			selectedUsers: [],
			activePrompt: false,
			standardOutput: null,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	computed: {
		validateCost() {
			return (cost) => {
				return cost.distance == null && cost.fixed == null && cost.time == null && cost.traveled_hour == null;
			};
		},
		selectedRoutingType() {
			return this.$store.state.routingType;
		},
		thead_property_names() {
			return {
				n: "N",
				type: this.$t("Routing.Table.Type"),
				identification: this.$t("Routing.Table.Identification"),
				estimatedTimeArrival: this.$t("Routing.Table.EstimatedTimeArrival"),
				waitingTime: this.$t("Routing.Table.WaitingTime"),
				estimatedStartTask: this.$t("Routing.Table.EstimatedStartTask"),
				timeService: this.$t("Routing.Table.TimeService"),
				estimatedDepartureTime: this.$t("Routing.Table.EstimatedDepartureTime"),
				distanceFromPrevious: this.$t("Routing.Table.DistanceFromPrevious"),
				totalDistanceTraveled: this.$t("Routing.Table.TotalDistanceTraveled"),
				actions: this.$t("Teams.Table.Action"),
				titleButton: this.$t("SeeDetailedInformation"),
				additionalFields: this.$t("AdditionalFields"),
				name: this.$t("Routing.Table.Name"),
				capacityValue: this.$t("ResourceModule.Create.CapacityValue"),
				demands: this.$t("VisitPoints.Demands"),
				skills: this.$t("Skills.Skills"),
				permittedVehicles: this.$t("Vehicles.PermittedVehicles"),
				timeWindows: this.$t("TimeWindow.TimeWindows"),
				initDate: this.$t("CompanyCreate.InitDate"),
				endDate: this.$t("CompanyCreate.EndDate"),
				territoryId: this.$t("Territories.TerritoryID"),
				Break: this.$t("Routing.Table.Break"),
				Depot: this.$t("Routing.Table.Depot"),
				Pickup: this.$t("Routing.Table.Pickup"),
				Delivery: this.$t("Routing.Table.Delivery"),
			};
		},
		chipColor() {
			return (value) => {
				if (value === 100.0) {
					return "success";
				}
				if (value >= 50.0 && value < 100.0) {
					return "warning";
				} else if (value >= 1.0 && value < 50.0) {
					return "primary";
				}
				return "primary";
			};
		},
		getLoadCapacity() {
			return (dataVehicle, name) => {
				let loadCapacity = [];
				if (dataVehicle.load_capacity.length > 0) {
					loadCapacity = dataVehicle.load_capacity.filter((load) => load.name === name);
					return loadCapacity[0].amount;
				}
				return 0;
			};
		},
		getLoadCapacityPercentage() {
			return (dataVehicle, name) => {
				let loadCapacityPercentage = [];
				if (dataVehicle.load_capacity_percentage.length > 0) {
					loadCapacityPercentage = dataVehicle.load_capacity_percentage.filter((load) => load.name === name);
					return Math.round(loadCapacityPercentage[0].percentage);
				}
				return 0;
			};
		},
	},
	methods: {
		exportToExcel() {
			import("@/vendor/Export2Excel").then((excel) => {
				const list = this.selectedUsers;
				const data = this.formatJson(this.headerVal, list);
				excel.export_json_to_excel({
					header: this.headerTitle,
					data,
					filename: this.fileName,
					autoWidth: this.cellAutoWidth,
					bookType: this.selectedFormat,
				});
				this.clearFields();
			});
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) =>
				filterVal.map((j) => {
					return v[j];
				})
			);
		},
		clearFields() {
			this.fileName = "";
			this.cellAutoWidth = true;
			this.selectedFormat = "xlsx";
		},
	},
	filters: {
		removeDecimals(num = 0.03) {
			return num.toFixed(1);
		},
	},
	created() {
		if (!moduleRouting.isRegistered) {
			this.$store.registerModule("moduleRouting", moduleRouting);
			moduleRouting.isRegistered = true;
		}
	},
	mounted() {
		this.standardOutput = this.$store.getters["moduleRouting/getStandardOutput"]();
		this.routedVehicles = this.standardOutput.routed_vehicles;
	},
};
</script>
<style scoped>
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: auto;
	max-height: 250px;
}
</style>
